import { normalizeMockDatabase } from './normalize'
import { createMockSeed } from './seed'
import type { MockDatabase } from './schema'
import { cloneDb } from '../utils/persist'

const DB_STORAGE_KEY = 'ui-mock-control-plane-db-v1'
let cache: MockDatabase | null = null

const isBrowser = () => typeof window !== 'undefined'

export const resetMockDb = (): MockDatabase => {
  const seed = normalizeMockDatabase(createMockSeed())
  cache = seed
  if (isBrowser()) {
    window.localStorage.setItem(DB_STORAGE_KEY, JSON.stringify(seed))
  }
  return cloneDb(seed)
}

export const readMockDb = (): MockDatabase => {
  if (cache) return cloneDb(cache)
  if (isBrowser()) {
    const raw = window.localStorage.getItem(DB_STORAGE_KEY)
    if (raw) {
      try {
        const parsed = JSON.parse(raw) as MockDatabase
        normalizeMockDatabase(parsed)
        cache = parsed
        return cloneDb(parsed)
      } catch {
        return resetMockDb()
      }
    }
  }
  return resetMockDb()
}

export const writeMockDb = (next: MockDatabase): MockDatabase => {
  cache = cloneDb(next)
  if (isBrowser()) {
    window.localStorage.setItem(DB_STORAGE_KEY, JSON.stringify(next))
  }
  return cloneDb(next)
}

export const mutateMockDb = (updater: (db: MockDatabase) => void): MockDatabase => {
  const db = readMockDb()
  updater(db)
  return writeMockDb(db)
}
